export const ENDPOINTS = {
    CREATE_REFERRER: {
        method: 'POST',
        path: '/thirdpartyapis/referrer',
        scope: 'referrer:create',
    },
    SEND_REFERRAL: {
        method: 'POST',
        path: '/thirdpartyapis/referral',
        scope: 'referrals:create',
    },
    UPDATE_REFERRAL_STATUS: {
        method: 'POST',
        path: '/thirdpartyapis/update-referral-status',
    },
    GET_REWARDS: {
        method: 'GET',
        path: '/thirdpartyapis/reward',
    },
    GET_REFERRALS: {
        method: 'GET',
        path: '/thirdpartyapis/get-my-referral-list',
    },
    PAY_REFERRAL: {
        method: 'POST',
        path: '/thirdpartyapis/pay-referral',
    },
    PAY_REFERRER: {
        method: 'POST',
        path: '/thirdpartyapis/pay-referrer',
    },
};


